/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-undef */
import { ForecastNavigation } from './forecastNavigation';

const props = [];

export const ForecastNavigationDirective = reactDirective => reactDirective(ForecastNavigation, props);
ForecastNavigationDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('forecastNavigation', ForecastNavigationDirective);
